import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex flex-wrap pt-3 p-8 pb-0 working-schedule-box" }
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = { class: "flex flex-wrap" }
const _hoisted_4 = { class: "working-schedule-container" }
const _hoisted_5 = { class: "working-schedule-header" }
const _hoisted_6 = { class: "working-schedule__desc" }
const _hoisted_7 = { class: "working-schedule__box" }
const _hoisted_8 = { class: "target-date" }
const _hoisted_9 = { class: "target-date__desc" }
const _hoisted_10 = { class: "target-date__time" }
const _hoisted_11 = { class: "patter-box" }
const _hoisted_12 = { class: "patter-box__desc" }
const _hoisted_13 = { class: "flex flex-wrap patter-box__header" }
const _hoisted_14 = /*#__PURE__*/_createVNode("span", { class: "pl-2 pr-2" }, ":", -1)
const _hoisted_15 = { class: "patter-box__time" }
const _hoisted_16 = { class: "patter-box__container m-0-auto" }
const _hoisted_17 = { class: "patter-box__content flex" }
const _hoisted_18 = { class: "flex flex-col mr-10" }
const _hoisted_19 = { class: "mb-2" }
const _hoisted_20 = { class: "pr-1" }
const _hoisted_21 = { class: "pl-1" }
const _hoisted_22 = { class: "pr-1" }
const _hoisted_23 = { class: "pl-1" }
const _hoisted_24 = { class: "flex flex-col ml-12" }
const _hoisted_25 = { class: "mb-2" }
const _hoisted_26 = { class: "pr-1" }
const _hoisted_27 = { class: "pl-1" }
const _hoisted_28 = { class: "pr-1" }
const _hoisted_29 = { class: "pl-1" }
const _hoisted_30 = { class: "stamp-editing" }
const _hoisted_31 = { class: "stamp-editing__desc" }
const _hoisted_32 = { class: "box-total-working" }
const _hoisted_33 = { class: "flex w-full justify-between" }
const _hoisted_34 = { class: "flex w-full justify-between" }
const _hoisted_35 = {
  key: 0,
  class: "shift-pattern-box"
}
const _hoisted_36 = { class: "shift-pattern-select flex items-baseline" }
const _hoisted_37 = /*#__PURE__*/_createVNode("span", { class: "pl-2 pr-2" }, ":", -1)
const _hoisted_38 = { class: "w-select-working" }
const _hoisted_39 = { class: "p-5" }
const _hoisted_40 = { class: "flex justify-center" }
const _hoisted_41 = { class: "shift-patterns-time flex justify-center mr-12" }
const _hoisted_42 = /*#__PURE__*/_createVNode("span", { class: "pl-1 pr-1" }, ":", -1)
const _hoisted_43 = { class: "shift-patterns-time__hour" }
const _hoisted_44 = { class: "shift-patterns-time flex justify-center" }
const _hoisted_45 = /*#__PURE__*/_createVNode("span", { class: "pl-1 pr-1" }, ":", -1)
const _hoisted_46 = { class: "shift-patterns-time__hour" }
const _hoisted_47 = { class: "flex justify-center" }
const _hoisted_48 = { class: "shift-patterns-time flex justify-center mr-12" }
const _hoisted_49 = /*#__PURE__*/_createVNode("span", { class: "pl-1 pr-1" }, ":", -1)
const _hoisted_50 = { class: "shift-patterns-time__hour" }
const _hoisted_51 = { class: "shift-patterns-time flex justify-center" }
const _hoisted_52 = /*#__PURE__*/_createVNode("span", { class: "pl-1 pr-1" }, ":", -1)
const _hoisted_53 = { class: "shift-patterns-time__hour" }
const _hoisted_54 = {
  key: 1,
  class: "w-full flex justify-center items-baseline"
}
const _hoisted_55 = { class: "mt-8" }
const _hoisted_56 = { class: "flex items-baseline" }
const _hoisted_57 = /*#__PURE__*/_createVNode("span", { class: "pl-1 pr-4" }, ":", -1)
const _hoisted_58 = { class: "mr-2" }
const _hoisted_59 = { class: "flex items-baseline" }
const _hoisted_60 = /*#__PURE__*/_createVNode("span", { class: "pl-1 pr-4" }, ":", -1)
const _hoisted_61 = { class: "mr-2" }
const _hoisted_62 = { class: "reason-application" }
const _hoisted_63 = { class: "target-date__desc stamp-editing__desc" }
const _hoisted_64 = { class: "stamp-button flex justify-center mt-8 flex-col" }
const _hoisted_65 = { class: "button-apply hover:opacity-75" }
const _hoisted_66 = { class: "button-cancel" }
const _hoisted_67 = /*#__PURE__*/_createVNode("div", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Label = _resolveComponent("Label")
  const _component_RadioGroup = _resolveComponent("RadioGroup")
  const _component_Select = _resolveComponent("Select")
  const _component_Input = _resolveComponent("Input")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("p", _hoisted_6, _toDisplayString(_ctx.t('workingScheduleRegister.workScheduleChangeApplication')), 1)
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _createVNode("p", _hoisted_9, _toDisplayString(_ctx.t('overtimeRegister.targetDate')), 1),
              _createVNode("div", _hoisted_10, _toDisplayString(_ctx.t('overtimeRegister.exampleDate')), 1)
            ]),
            _createVNode("div", _hoisted_11, [
              _createVNode("p", _hoisted_12, _toDisplayString(_ctx.t('workingScheduleRegister.currentWorkSchedule')), 1),
              _createVNode("div", _hoisted_13, [
                _createVNode(_component_Label, {
                  "text-label": _ctx.t('workingScheduleRegister.shiftPatternName')
                }, null, 8, ["text-label"]),
                _hoisted_14,
                _createVNode("p", _hoisted_15, _toDisplayString(_ctx.t('workingScheduleRegister.patternTimeExample')), 1)
              ]),
              _createVNode("div", _hoisted_16, [
                _createVNode("div", _hoisted_17, [
                  _createVNode("div", _hoisted_18, [
                    _createVNode("p", _hoisted_19, [
                      _createVNode("span", _hoisted_20, _toDisplayString(_ctx.t('overtimeRegister.attendanceAtWorkLb')) + ":", 1),
                      _createVNode("span", _hoisted_21, _toDisplayString(_ctx.t('overtimeRegister.timeExample')), 1)
                    ]),
                    _createVNode("p", null, [
                      _createVNode("span", _hoisted_22, _toDisplayString(_ctx.t('stampRegister.breakStart')) + ":", 1),
                      _createVNode("span", _hoisted_23, _toDisplayString(_ctx.t('workingScheduleRegister.timeExample')), 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_24, [
                    _createVNode("p", _hoisted_25, [
                      _createVNode("span", _hoisted_26, _toDisplayString(_ctx.t('stampRegister.leavingWork')) + " :", 1),
                      _createVNode("span", _hoisted_27, _toDisplayString(_ctx.t('overtimeRegister.timeExample2')), 1)
                    ]),
                    _createVNode("p", null, [
                      _createVNode("span", _hoisted_28, _toDisplayString(_ctx.t('stampRegister.breakEnd')) + " :", 1),
                      _createVNode("span", _hoisted_29, _toDisplayString(_ctx.t('workingScheduleRegister.timeExample1')), 1)
                    ])
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_30, [
              _createVNode("p", _hoisted_31, _toDisplayString(_ctx.t('workingScheduleRegister.workScheduleAfterChange')), 1),
              _createVNode("div", _hoisted_32, [
                _createVNode("div", _hoisted_33, [
                  _createVNode(_component_RadioGroup, {
                    default: 0,
                    class: "mt-2 w-full",
                    "options-radio": _ctx.workScheduleChangeOption,
                    modelValue: _ctx.workingScheduleRegisterParams.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.workingScheduleRegisterParams.value = $event))
                  }, null, 8, ["options-radio", "modelValue"])
                ]),
                _createVNode("div", _hoisted_34, [
                  (_ctx.workingScheduleRegisterParams.value === 0)
                    ? (_openBlock(), _createBlock("div", _hoisted_35, [
                        _createVNode("div", _hoisted_36, [
                          _createVNode(_component_Label, {
                            "text-label": 
                          _ctx.t('workingScheduleRegister.shiftPatternName')
                        
                          }, null, 8, ["text-label"]),
                          _hoisted_37,
                          _createVNode("div", _hoisted_38, [
                            _createVNode(_component_Select, {
                              placeholder: 
                            _ctx.t('overtimeRegister.placeholderSelectOvertime')
                          ,
                              optionsSelect: _ctx.optionReasonApplication,
                              "item-text": "text"
                            }, null, 8, ["placeholder", "optionsSelect"])
                          ])
                        ]),
                        _createVNode("div", _hoisted_39, [
                          _createVNode("div", _hoisted_40, [
                            _createVNode("div", _hoisted_41, [
                              _createVNode(_component_Label, {
                                "text-label": _ctx.t('checkIn')
                              }, null, 8, ["text-label"]),
                              _hoisted_42,
                              _createVNode("span", _hoisted_43, _toDisplayString(_ctx.t('overtimeRegister.timeExample')), 1)
                            ]),
                            _createVNode("div", _hoisted_44, [
                              _createVNode(_component_Label, {
                                "text-label": _ctx.t('checkIn')
                              }, null, 8, ["text-label"]),
                              _hoisted_45,
                              _createVNode("span", _hoisted_46, _toDisplayString(_ctx.t('overtimeRegister.timeExample2')), 1)
                            ])
                          ]),
                          _createVNode("div", _hoisted_47, [
                            _createVNode("div", _hoisted_48, [
                              _createVNode(_component_Label, {
                                "text-label": _ctx.t('breakStartTimeRounding')
                              }, null, 8, ["text-label"]),
                              _hoisted_49,
                              _createVNode("span", _hoisted_50, _toDisplayString(_ctx.t('workingScheduleRegister.timeExample')), 1)
                            ]),
                            _createVNode("div", _hoisted_51, [
                              _createVNode(_component_Label, {
                                "text-label": _ctx.t('breakStartTimeRounding')
                              }, null, 8, ["text-label"]),
                              _hoisted_52,
                              _createVNode("span", _hoisted_53, _toDisplayString(_ctx.t('workingScheduleRegister.timeExample1')), 1)
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.workingScheduleRegisterParams.value === 1)
                    ? (_openBlock(), _createBlock("div", _hoisted_54, [
                        _createVNode("div", _hoisted_55, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.paramsWorkingScheduleRegister, (item, index) => {
                            return (_openBlock(), _createBlock("div", {
                              class: "flex align-center mb-3 items-baseline",
                              key: index,
                              id: item
                            }, [
                              _createVNode("div", _hoisted_56, [
                                _createVNode(_component_Label, {
                                  "text-label": 
                              _ctx.t('overtimeRegister.attendanceAtWorkLb')
                            
                                }, null, 8, ["text-label"]),
                                _hoisted_57
                              ]),
                              _createVNode("div", _hoisted_58, [
                                _createVNode(_component_Input, {
                                  modelValue: 
                              _ctx.paramsWorkingScheduleRegister[index]
                                .break_time_minute
                            ,
                                  "onUpdate:modelValue": ($event: any) => (
                              _ctx.paramsWorkingScheduleRegister[index]
                                .break_time_minute
                             = $event),
                                  type: "time",
                                  placeholder: _ctx.t('overtimeRegister.textDateExample')
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
                              ]),
                              _createVNode("div", _hoisted_59, [
                                _createVNode(_component_Label, {
                                  "text-label": _ctx.t('overtimeRegister.leavingWork')
                                }, null, 8, ["text-label"]),
                                _hoisted_60
                              ]),
                              _createVNode("div", _hoisted_61, [
                                _createVNode(_component_Input, {
                                  type: "time",
                                  modelValue: _ctx.paramsWorkingScheduleRegister[index].time,
                                  "onUpdate:modelValue": ($event: any) => (_ctx.paramsWorkingScheduleRegister[index].time = $event)
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ])
                            ], 8, ["id"]))
                          }), 128))
                        ]),
                        _createVNode("div", null, [
                          _createVNode("span", {
                            class: "flex action--add",
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addWorkingScheduleRegister && _ctx.addWorkingScheduleRegister(...args)))
                          }, [
                            _createVNode("img", {
                              src: _ctx.Plus,
                              alt: "",
                              srcset: ""
                            }, null, 8, ["src"]),
                            _createTextVNode(_toDisplayString(_ctx.t('addAction')), 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createVNode("div", _hoisted_62, [
              _createVNode("p", _hoisted_63, _toDisplayString(_ctx.t('overtimeRegister.ReasonApplication')), 1),
              _createVNode(_component_Select, {
                placeholder: _ctx.t('enterTheApplicationMessage'),
                optionsSelect: _ctx.optionReasonApplication,
                "item-text": "text"
              }, null, 8, ["placeholder", "optionsSelect"])
            ])
          ]),
          _createVNode("div", _hoisted_64, [
            _createVNode("button", _hoisted_65, _toDisplayString(_ctx.t('overtimeRegister.buttonApply')), 1),
            _createVNode("button", _hoisted_66, _toDisplayString(_ctx.t('overtimeRegister.buttonCancel')), 1),
            _hoisted_67
          ])
        ])
      ])
    ])
  ]))
}